import React from "react";
import { Typography, Grid } from "@material-ui/core";

const Footer = ({ text, children }) => (
  <Grid container direction="column" justify="flex-end" alignItems="center">
    {children && <Grid>{children}</Grid>}
    <Grid item>
      <Typography variant="caption">{text}</Typography>
    </Grid>
    <Grid item style={{ marginBottom: 32 }}>
      <a
        href="https://oddadigitalsystem.no"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          style={{ display: "block" }}
          alt="Odda Digital System Logo"
          src={process.env.PUBLIC_URL + "/assets/ods_logo.png"}
          height={40}
        />
      </a>
    </Grid>
  </Grid>
);

export default Footer;
